document.addEventListener('alpine:init', () => {
    Alpine.store('chatmeta', { enabled: false });
    Alpine.store('chatbox_meta', { enabled: false });
    Alpine.store('chat_welcome', { enabled: false });
    Alpine.store('chathours', { enabled: false });
    Alpine.store('chat_inactive_tooltip', { enabled: false })
    Alpine.store('chatbody', {
        chat: [],
        messages: [],
        input: "",
        uuid: null,
        assistant_response: "",
        isTyping: false, // Added for typing indicator
        isTypingTimeout: false, // Timeout for typing indicator
        pagesViewed: { views: 0, expDate: null },
        greetings: [
            "Hi ich bin KorKI, was kann ich heute für dich tun? 😊",
            "Hallo, wie kann ich dir helfen? 👋",
            "Hey, ich bin KorKI, was möchtest du wissen?",
            "Hallo! Ich bin hier, um dir zu helfen. Was kann ich für dich tun?",
            "Hi! Ich bin KorKI, der neue Assistent für Ankerkraut. Was kann ich für dich tun?",
            "Moin! Was liegt dir auf dem Herzen? Ich bin hier, um zu helfen! 😊",
            "Moin, was kann ich heute für dich tun?",
            "Moin, was möchtest du heute wissen?",
        ],
        long_responses: [
            "Es tut mir leid, gerade dauert die Anfrage etwas länger, hab einen Moment Geduld.",
            "Entschuldige, manchmal muss ich etwas länger nachdenken, aber ich bin gleich bei dir!",
            "Ich entschuldige mich, manchmal dauert es etwas länger, bis ich eine Antwort habe. Bitte hab einen Moment Geduld.",
            "Entschuldige, ich muss gerade länger nachdenken, aber ich werde dir gleich antworten!",
            "Es tut mir leid, ich brauche einen Moment länger, um die beste Antwort zu finden. Bitte hab Geduld.",
            "Entschuldige, ich bin gerade etwas langsamer als gewohnt. Ich werde dir gleich antworten!",
            "Entschuldigung, lass mich kurz nachdenken, ich bin gleich wieder da!",
        ],
        really_long_responses: [
            "Entschuldige, vermutlich starte ich gerade neu oder muss sehr viele Anfragen aufeinmal verarbeiten. Schau dich erstmal weiter im Shop um und komm gleich nochmal vorbei, ich bin so schnell wie möglich bei dir!",
            "Es tut mir leid, ich bin gerade etwas überlastet. Schau dich in der Zwischenzeit gerne im Shop um und komm gleich nochmal vorbei!",
            "Entschuldige, ich bin gerade etwas überlastet. Schau dich in der Zwischenzeit gerne im Shop um und komm gleich wieder vorbei!",
            "Tut mir leid, dass du so lange warten musst. Ich bin gerade etwas überlastet oder starte neu. Stöber ein bisschen im Shop, ich bin gleich für dich da!",
            "Entschuldigung, dass ich so lange brauche. Schau dich kurz im Shop um, ich bin gleich wieder für dich da!",
        ],
        
        init() {
            Alpine.store('chatbody').uuid = localStorage.getItem('assistant_uuid') || null;
            let viewed = JSON.parse(localStorage.getItem('pages_viewed'));

            Alpine.store('chatbody').pagesViewed = viewed ? { views: viewed.views + 1, expDate: viewed.expDate } : { views: 1, expDate: new Date().setHours(new Date().getHours() + 3) };
            localStorage.setItem('pages_viewed', JSON.stringify(Alpine.store('chatbody').pagesViewed));
            if (Alpine.store('chatmeta').enabled == true) {
                Alpine.store('chatbody').loadConversation();
                Alpine.store('chatbody').get_page_viewed();
            }
            setTimeout(() => {
                Alpine.store('chat_welcome').enabled = false;
            }, 10000);
            const now = new Date();
            if (now.getHours() < 14 || now.getHours() >= 20) {
                Alpine.store('chat_welcome').enabled = false;
                Alpine.store('chathours').enabled = false;
            } else {
                if (Alpine.store('chatbody').pagesViewed.expDate < now.getTime()) {
                    Alpine.store('chatbody').pagesViewed = { views: 1, expDate: new Date().setHours(new Date().getHours() + 3) };
                }
                if (Alpine.store('chatbody').pagesViewed.views <= 2) {
                    Alpine.store('chat_welcome').enabled = true;
                    Alpine.store('chatbody').pagesViewed.views += 1;
                }
                Alpine.store('chathours').enabled = true;
            }
            setTimeout(() => {
                const messagesContainer = document.getElementById('chatbox-messages');
                if (messagesContainer) {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                }
            }, 100);
        },
        initChat() {
            if (Alpine.store('chatbody').messages.length > 0) return;
            const modelMessage = {
                id: Date.now(),
                text: Alpine.store('chatbody').greetings[Math.floor(Math.random() * this.greetings.length)],
                sender: 'model',
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            };
            Alpine.store('chatbody').messages.push(modelMessage);
            var body = JSON.stringify({
                "uuid": localStorage.getItem('assistant_uuid'),
                "stats": {
                    "chat_opened": true,
                    "overlay_loaded": false,
                },
                "chatmeta": Alpine.store('chatmeta').enabled,
            });
            fetch('https://assistant.ankerkraut.de/interacted', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        Alpine.store('chatbody').uuid = data.uuid;
                        localStorage.setItem('assistant_uuid', data.uuid);
                        console.log(Alpine.store('chatbody').uuid)
                    }).catch(error => {
                        console.error('Error parsing response:', error);
                    });
                } else {
                    console.error('Error:', response.statusText);
                }
            }).catch(error => {
                console.error('Error:', error);
            });
        },
        sendMessage() {
            Alpine.store('chatbody').uuid = localStorage.getItem('assistant_uuid') || null;
            startRandomTimerProgress(15000); // Start the random progress timer
            if (Alpine.store('chatbody').input.trim() === '') return;

            const userMessage = {
                id: Date.now(),
                text: Alpine.store('chatbody').input,
                sender: 'user',
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            };

            Alpine.store('chatbody').chat.push({ role: 'user', content: Alpine.store('chatbody').input });
            Alpine.store('chatbody').messages.push(userMessage);
            Alpine.store('chatbody').input = "";
            Alpine.store('chatbody').isTyping = true;

            setTimeout(() => {
                const messagesContainer = document.getElementById('chatbox-messages');
                if (messagesContainer) {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                }
            }, 100);
            let body = JSON.stringify({
                "messages": Alpine.store('chatbody').chat, // Previous messages
                "uuid": Alpine.store('chatbody').uuid
            });

            const responseTimeout = setTimeout(() => {
                Alpine.store('chatbody').messages.push({
                    id: Date.now(),
                    text: Alpine.store('chatbody').long_responses[Math.floor(Math.random() * Alpine.store('chatbody').long_responses.length)],
                    sender: 'model',
                    time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    isTimeout: true
                });

                stopRandomTimerProgress();
                Alpine.store('chatbody').isTyping = false;
                Alpine.store('chatbody').isTypingTimeout = true;
                setTimeout(() => {
                    const messagesContainer = document.getElementById('chatbox-messages');
                    if (messagesContainer) {
                        messagesContainer.scrollTop = messagesContainer.scrollHeight;
                    }
                }, 100);
            }, 15000);
            const restartTimeout = setTimeout(() => {
                Alpine.store('chatbody').messages.push({
                    id: Date.now(),
                    text: Alpine.store('chatbody').really_long_responses[Math.floor(Math.random() * Alpine.store('chatbody').really_long_responses.length)],
                    sender: 'model',
                    time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    isTimeout: true
                });
                setTimeout(() => {
                    const messagesContainer = document.getElementById('chatbox-messages');
                    if (messagesContainer) {
                        messagesContainer.scrollTop = messagesContainer.scrollHeight;
                    }
                }, 100);
            }, 35000);
            fetch(
                'https://assistant.ankerkraut.de/inference',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body,
                }
            ).then(async response => {
                clearTimeout(responseTimeout);
                clearTimeout(restartTimeout);
                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');
                let done = false;
                let responseText = '';
                Alpine.store("chatbody").isTyping = false;
                Alpine.store("chatbody").isTypingTimeout = false;
                let counter = 0;
                while (!done) {
                    const { value, done: doneReading } = await reader.read();
                    done = doneReading;
                    console.log("Received chunk:", value);
                    if (value) {
                        responseText += decoder.decode(value, { stream: true });
                        console.log("Decoded chunk:", JSON.stringify(responseText));
                        if (counter == 0) {
                            responseText = responseText.trim(); // Remove leading whitespace if present
                            counter++;
                        }

                        Alpine.store('chatbody').appendMessage(responseText);

                        responseText = '';
                    }
                    Alpine.store('chatbody').assistant_response = Alpine.store('chatbody').messages[Alpine.store('chatbody').messages.length - 1].text;
                }
                Alpine.store('chatbody').chat.push({ role: 'model', content: Alpine.store('chatbody').assistant_response });

            }).catch(error => {
                    clearTimeout(responseTimeout);
                    clearTimeout(restartTimeout);
                    console.error('Error:', error);
                    var message = "Es tut mir leid, da ist etwas schiefgelaufen, versuche es später noch einmal!"
                    if (error.status === 400) {
                        message = "Es tut mir leid, die Anfrage verstößt gegen meine Richtlinien. Bitte stelle eine andere Frage oder formuliere deine Anfrage um.";
                    }
                    Alpine.store('chatbody').isTyping = false;
                    Alpine.store('chatbody').isTypingTimeout = false;
                    // Add error message
                    Alpine.store('chatbody').messages = Alpine.store('chatbody').messages.filter(
                        msg => !msg.isTimeout
                    );
                    Alpine.store('chatbody').messages.pop();
                    if (Alpine.store('chatbody').chat.length % 2 === 0) {
                        Alpine.store('chatbody').chat.pop();
                    }
                    Alpine.store('chatbody').messages.push({
                        id: Date.now(),
                        text: message,
                        sender: 'model',
                        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    });
                    Alpine.store('chatbody').assistant_response = message;
                })
        },

        appendMessage(newText) {

            const lastMessage = this.messages[this.messages.length - 1];
            if (lastMessage && lastMessage.sender === 'model') {
                lastMessage.text += newText;
                this.messages = [...this.messages];
            } else {
                this.messages.push({
                    id: Date.now(),
                    text: newText,
                    sender: 'model',
                    time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                });
            }
            setTimeout(() => {
                const messagesContainer = document.getElementById('chatbox-messages');
                if (messagesContainer) {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                }
            }, 100);
        },

        answer_user(response) {
            // Hide typing indicator
            Alpine.store('chatbody').isTyping = false;
            Alpine.store('chatbody').isTypingTimeout = false;
            stopRandomTimerProgress();
            if (response.status === 200) {
                response.json().then(data => {
                    Alpine.store('chatbody').assistant_response = data.response;
                    if (Alpine.store('chatbody').uuid == null) {
                        localStorage.setItem('assistant_uuid', data.uuid);
                        Alpine.store('chatbody').uuid = data.uuid;
                    }
                    Alpine.store('chatbody').append_uuid();
                    // Add model response to chat
                    const modelMessage = {
                        id: Alpine.store('chatbody').uuid + Date.now(),
                        text: Alpine.store('chatbody').assistant_response,
                        sender: 'model',
                        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    };
                    Alpine.store('chatbody').messages = Alpine.store('chatbody').messages.filter(
                        msg => !msg.isTimeout
                    );
                    Alpine.store('chatbody').chat.push({ role: 'model', content: Alpine.store('chatbody').assistant_response });
                    Alpine.store('chatbody').messages.push(modelMessage);

                    // Scroll to bottom
                    setTimeout(() => {
                        const messagesContainer = document.getElementById('chatbox-messages');
                        if (messagesContainer) {
                            messagesContainer.scrollTop = messagesContainer.scrollHeight;
                        }
                    }, 100);
                });
            } else {
                console.error('Error:', response.statusText);
                Alpine.store('chatbody').messages.push({
                    id: Alpine.store('chatbody').uuid + Date.now(),
                    text: "Es tut mir leid, da ist etwas schiefgelaufen, versuche es später noch einmal!",
                    sender: 'model',
                    time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                });
            }
        },
        append_uuid() {
            var uuid = localStorage.getItem('assistant_uuid');
            var formData = new FormData();
            formData.append("attributes[assistant-uuid]", uuid);
            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => console.log("found uuid, setting cart attribute:", data.attributes));
        },
        loadConversation() {
            Alpine.store('chatbody').uuid = localStorage.getItem('assistant_uuid') || null;
            if (Alpine.store('chatbody').uuid == null) return;
            var body = JSON.stringify({
                "uuid": Alpine.store('chatbody').uuid,
                "stats": {
                    "chat_opened": false,
                    "overlay_loaded": true,
                },
                "chatmeta": Alpine.store('chatmeta').enabled,
            });
            fetch('https://assistant.ankerkraut.de/conversation', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body,
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        data.forEach(message => {
                            Alpine.store('chatbody').messages.push({
                                id: message.id,
                                text: message.user_request,
                                sender: 'user',
                                time: new Date(message.conversation_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                            });
                            Alpine.store('chatbody').messages.push({
                                id: message.id,
                                text: message.chatbot_response,
                                sender: 'model',
                                time: new Date(message.conversation_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                            });
                            Alpine.store('chatbody').chat.push({ role: 'user', content: message.user_request });
                            Alpine.store('chatbody').chat.push({ role: 'model', content: message.chatbot_response });

                            if (Alpine.store('chatbody').chat.length > 10) {
                                Alpine.store('chatbody').chat.splice(0, 2)
                            }
                        });
                        Alpine.store('chatbody').uuid = data.uuid;
                    }).catch(error => {
                        return
                    });
                }
            }).catch(error => {
                console.error('Error:', error);
            });
        },
        get_page_viewed() {
            var current_url = window.location.href;
            if (current_url.includes('assistant=true') && localStorage.getItem('assistant_uuid') != null) {
                var body = JSON.stringify({
                    "uuid": Alpine.store("chatbody").uuid, // Previous messages
                    "page": current_url,
                });
                fetch('https://assistant.ankerkraut.de/viewed', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body,
                }).then(response => {
                    if (response.status === 200) {
                        console.log("Viewed page logged successfully");
                    } else {
                        console.error('Error logging viewed page:', response.statusText);
                    }
                }).catch(error => {
                    console.error('Error:', error);
                });
            }
        }
    });
    Alpine.store('chat_loading', {
        circularProgress() {
            return {
                offset: 87.96, // circumference for r=14
                timer: null,
                progress: 0,
                start(duration = 3000) {
                    this.offset = 87.96;
                    this.progress = 0;
                    if (this.timer) clearInterval(this.timer);
                    const step = 20; // ms
                    const steps = duration / step;
                    this.timer = setInterval(() => {
                        // Randomly increase progress, but ensure it reaches 100% at the end
                        if (this.progress < 100) {
                            // Add a bit of randomness
                            this.progress += Math.random() * (100 / steps) * 1.5;
                            if (this.progress > 100) this.progress = 100;
                            this.offset = 87.96 - (this.progress / 100) * 87.96;
                        } else {
                            clearInterval(this.timer);
                        }
                    }, step);
                },
                stop() {
                    if (this.timer) clearInterval(this.timer);
                    this.progress = 100;
                    this.offset = 0;
                }
            }
        }
    })
});

let progressTimer = null;

function startRandomTimerProgress(totalDurationMs) {
    const circle = document.querySelector('.circular-progress .fg');
    if (!circle) return;

    const radius = 14;
    const circumference = 2 * Math.PI * radius;
    let currentProgress = 0;
    let startTime = Date.now();

    // Reset progress
    circle.style.strokeDashoffset = circumference;

    function updateProgress() {
        const elapsed = Date.now() - startTime;
        const timeBasedProgress = (elapsed / totalDurationMs) * 100;

        // Add random increment (but don't exceed time-based progress)
        const randomIncrement = Math.random() * 15;
        currentProgress = Math.min(currentProgress + randomIncrement, timeBasedProgress);

        // Cap at 100%
        currentProgress = Math.min(currentProgress, 100);

        // Update visual progress
        const offset = circumference - (currentProgress / 100) * circumference;
        circle.style.strokeDashoffset = offset;

        // Continue if not complete and within time limit
        if (currentProgress < 100 && elapsed < totalDurationMs) {
            progressTimer = setTimeout(updateProgress, Math.random() * 300 + 200); // 200-500ms intervals
        } else {
            // Ensure it reaches 100% at the end
            circle.style.strokeDashoffset = 0;
        }
    }

    updateProgress();
}

function stopRandomTimerProgress() {
    if (progressTimer) {
        clearTimeout(progressTimer);
        progressTimer = null;
    }

    const circle = document.querySelector('.circular-progress .fg');
    if (circle) {
        circle.style.strokeDashoffset = 0; // Complete the circle
    }
}